var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockRotateLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_306_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07617 7.20117L5.68164 5.80664C5.02539 5.19141 4 5.64258 4 6.50391V11.0156C4 11.5898 4.41016 12 4.98438 12H9.49609C10.3574 12 10.8086 10.9746 10.1934 10.3184L8.92188 9.08789C10.3574 7.65234 12.3262 6.75 14.5 6.75C18.8477 6.75 22.375 10.2773 22.375 14.625C22.375 18.9727 18.8477 22.5 14.5 22.5C12.8184 22.5 11.2598 22.0078 9.98828 21.1055C9.37305 20.6953 8.55273 20.8184 8.14258 21.4336C7.73242 22.0078 7.89648 22.8281 8.4707 23.2793C10.1934 24.4277 12.2441 25.125 14.5 25.125C20.2832 25.125 25 20.4492 25 14.625C25 8.8418 20.2832 4.125 14.5 4.125C11.5879 4.125 8.96289 5.31445 7.07617 7.20117ZM14.5 9.375C13.9258 9.375 13.5156 9.82617 13.5156 10.3594V14.625C13.5156 14.9121 13.5977 15.1582 13.8027 15.3223L16.7559 18.2754C17.125 18.6855 17.7402 18.6855 18.1094 18.2754C18.5195 17.9062 18.5195 17.291 18.1094 16.9219L15.4434 14.2559V10.3594C15.4434 9.82617 15.0332 9.375 14.459 9.375H14.5Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_306_17",
    x: 0,
    y: 0.125,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_306_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_306_17",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRotateLeft);
export default __webpack_public_path__ + "static/media/clock-rotate-left.6cc5c59a04136c239c29458fe0b1f97c.svg";
export { ForwardRef as ReactComponent };